var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"f-placeholder",class:_vm.classes},[(_vm.contentLoaded)?[_vm._t("default")]:[_c('span',{staticClass:"replacement-twin"},[_vm._v(_vm._s(_vm.replacement || ' '))]),_c('span',{staticClass:"replacement"},[_vm._v(_vm._s(_vm.replacement || ' '))])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }